import React from 'react'
import {
	BrowserRouter as Router
}from 'react-router-dom'
import Header from './containers/Menu/Header'
import Footer from './containers/Menu/Footer'
import './App.css'
import Routes from './routes'
import {
	Layout, ConfigProvider
}from 'antd'
import ruRU from 'antd/lib/locale/ru_RU'
import 'moment/locale/ru'

const App = () => {
	return (
		<Router>
			<ConfigProvider locale={ ruRU }>
				<Layout className="main-root-layout-ps">
					<Header />
					<Layout.Content className="layout-content">
						<Routes />
					</Layout.Content>
					<Footer />
				</Layout>
			</ConfigProvider>
		</Router>
	)
}

export default App
